  document.querySelectorAll('.star-rating').forEach(group => {

    const stars = group.querySelectorAll('span');

    stars.forEach((star, index) => {

      star.addEventListener('click', () => {

        const value = star.dataset.value;
        const target = group.dataset.target;

        document.getElementById(target).value = value;

        stars.forEach(s => s.classList.remove('active'));

        for (let i = 0; i < value; i++) {
          stars[i].classList.add('active');
        }

         updateAverageRating();

      });

    });

  });

window.addEventListener('load', () => {

  const form =
    document.getElementById('contact_form');


  form.addEventListener('submit', async (e) => {

    e.preventDefault();

    const requiredFields = [
    'product_quality',
    'customer_service',
    'delivery_experience',
    'ordering_process',
    'overall_satisfaction'
  ];

  for (let id of requiredFields) {
    const value = document.getElementById(id).value;

    if (!value) {
      alert("Please complete all star ratings before submitting.");
      return; // stops form submit
    }
  }

    const data = {

      name:
        form.querySelector(
          '[name="contact[Customer Name]"]'
        ).value,

      email:
        form.querySelector(
          '[name="contact[email]"]'
        ).value,

      product_quality:
        document.getElementById(
          'product_quality'
        ).value,

      customer_service:
        document.getElementById(
          'customer_service'
        ).value,

      delivery_experience:
        document.getElementById(
          'delivery_experience'
        ).value,

      ordering_process:
        document.getElementById(
          'ordering_process'
        ).value,

      overall_satisfaction:
        document.getElementById(
          'overall_satisfaction'
        ).value,

      average_rating:
        document.getElementById(
          'average_rating'
        ).value,

      feedback_message:
        form.querySelector(
          '[name="contact[Feedback Message]"]'
        ).value,
    };

    console.log(data);

    try {
    submitBtn.disabled = true;
    btnText.textContent = 'Submitting...';
    btnLoader.classList.remove('d-none');

       const response = await fetch(
        'https://script.google.com/macros/s/AKfycbxYINFt0mzyZHA7_nxW-HlxRKBjsqAzyYnbjAWEVy0QSULU4q_znicDfc57905DM7ZvLw/exec',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'text/plain'
          },
          body: JSON.stringify(data)
        }
      );
        const result = await response.json();

        console.log(result);

        if (result.success) {  
          form.classList.add('d-none');
          const formSuccess = document.querySelector('.feedback-success');
          formSuccess.classList.remove('d-none');

        } else {

          alert('Submission failed');

        }
    } catch(error) {

      console.error(error);

      alert('Something went wrong');

    } finally {
      submitBtn.disabled = false;
      btnText.textContent = 'Submit Feedback';
      btnLoader.classList.add('d-none');
    }

  });

});

  function updateAverageRating() {

  const fields = [
    'product_quality',
    'customer_service',
    'delivery_experience',
    'ordering_process',
    'overall_satisfaction'
  ];

  let total = 0;
  let count = 0;

  fields.forEach(id => {

    const value = parseInt(
      document.getElementById(id).value
    );

    if (!isNaN(value)) {
      total += value;
      count++;
    }

  });

  const average =
    count > 0
      ? (total / count).toFixed(1)
      : 0;

  document.getElementById(
    'average_rating_display'
  ).innerText = average;

  document.getElementById(
    'average_rating'
  ).value = average;

  const googleReviewWrapper =
    document.querySelector(
      '.google-review-consent'
    );

  if (parseFloat(average) >= 4) {

    googleReviewWrapper.classList.remove('d-none');

  } else {

    googleReviewWrapper.classList.add('d-none');
     document.getElementById(
    'googleReviewConsent'
  ).checked = false;


  }
}

const submitBtn = document.querySelector('.feedback-submit-btn');
const btnText = submitBtn.querySelector('.btn-text');
const btnLoader = submitBtn.querySelector('.btn-loader');

